<template>
  <div class="cervix-cont">
    <div class="assessment-cont">
      <div
        ref="imgCont"
        class="img-cont"
        :style="{ backgroundImage: `url(${bgUrl})` }"
      >
        <h3 class="title-txt">AI 体适能评估</h3>
        <p class="p-txt">仅需10-12分钟，即可获得评估报告，定制专属训练课程</p>
      </div>
      <p class="tips-txt">
        <template v-for="(item, index) in describes">
          {{ item }}
          <br v-if="index !== describes.length - 1" :key="index">
        </template>
      </p>
    </div>
    <div class="explain-cont">
      <h3 class="title-txt">动作讲解</h3>
      <div class="action-list">
        <div
          v-for="(item, index) in actionExplains"
          :key="index"
          class="li-cont"
          @click="handleOpenVideoDialog(index)"
        >
          <div class="video-img">
            <img class="img" :src="baseApi + item.bgImg">
            <img class="video-play" src="@/assets/images/video_play.png">
            <img class="play-circle" src="@/assets/images/play-circle.png">
          </div>
          <h3 class="li-title" v-text="item.functionName" />
          <span class="li-span" v-text="item.actionName" />
        </div>
      </div>
    </div>
    <div class="matters-cont">
      <!-- <h3 class="title-txt">{{ precautions.title }}</h3> -->
      <h3 class="title-txt">注意事项</h3>
      <ul class="ul-cont">
        <template v-for="(item, index) in riskAssess['content']">
          <li
            v-if="index !== riskAssess.content.length - 1"
            :key="index"
            class="li"
            v-text="item"
          />
          <div v-else :key="index" class="ul-cont-check">
            <el-checkbox v-model="checked"><span>{{ item }}</span></el-checkbox>
          </div>
        </template>
      </ul>
    </div>
    <div class="submit-cont">
      <el-button
        type="primary"
        class="submit-btn"
        :disabled="!checked"
        @click="handleJumpTo"
      >完善信息</el-button>
      <div class="logo-tips">
        <img class="logo-txt" src="@/assets/images/logo_txt.png">
        <span>提供技术支持</span>
      </div>
    </div>
    <el-dialog
      class="video-dialog"
      :modal="false"
      :destroy-on-close="true"
      top="0"
      width="66.11328vw"
      :visible.sync="dialogVisible"
      center
    >
      <!-- 设置播放器容器 -->
      <video
        id="player-container"
        :key="videItemIndex"
        :poster="poster"
        class="player-container"
        preload="metadata"
        controls
        playsinline
        webkit-playsinline
        :src="videoSrc"
      />
      <template v-slot:footer>
        <div class="prev-btn" @click="prevVideo">
          <el-icon class="el-icon-back" />
          <span>上个动作</span>
        </div>
        <h3>{{ videItemIndex + 1 }}/5</h3>
        <div class="next-btn" @click="nextVideo">
          <span>下个动作</span>
          <el-icon class="el-icon-right" />
        </div>
      </template>
    </el-dialog>
    <el-dialog
      v-if="false"
      class="remind-dialog"
      :modal="false"
      :title="riskAssess.title"
      top="0"
      width="66.11328vw"
      :visible.sync="remindVisible"
      :show-close="false"
    >
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseRemind">退出评估</el-button>
        <el-button type="primary" @click="handleJumpTo">同意并继续</el-button>
      </span>
      <template v-for="(item, index) in riskAssess.content">
        <div
          v-if="index !== riskAssess.content.length - 1"
          :key="index"
          class="remind-risk"
        >
          {{ item }}
        </div>
        <div v-else :key="index" class="remind-dialog-check">
          <el-checkbox v-model="checked"><span>{{ item }}</span></el-checkbox>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
const bgImg = require("../../../assets/images/assessment_bg.jpeg");
export default {
  name: "Cervix",
  data() {
    return {
      baseApi: "https://uadev-1257321318.cos.ap-beijing.myqcloud.com", // oss存储视频、图片地址
      actionExplains: [],
      riskAssess: {
        title: "注意事项",
        content: [],
      },
      checked: false,
      bgUrl: "",
      remindVisible: false,
      describes: [],
      precautions: {
        title: "",
        content: [],
      },
      dialogVisible: false,
      videItemIndex: 0,
      videoSrc: "",
      poster: "",
    };
  },
  async created() {
    await this.handleFetchIndexDetail();
  },
  methods: {
    handleCloseRemind() {
      this.remindVisible = false;
    },
    handleOpenRemind() {
      this.remindVisible = true;
    },
    // 跳转完善信息
    handleJumpTo() {
      // if (!this.checked) {
      // this.$message.error("请先阅读提示！");
      // } else {
      // this.remindVisible = false;
      this.$router.push({ path: "/questionnaire" });
      // }
    },
    // 获取门店端首页详情
    handleFetchIndexDetail() {
      this.$Api.stores
        .fetchIndexDetail()
        .then((res) => {
          if (res.actionExplains && res.actionExplains.length) {
            this.actionExplains = [].concat(res.actionExplains);
          }
          if (res.describes && res.describes.length) {
            this.describes = [].concat(res.describes);
          }
          res.riskAssess && (this.riskAssess = { ...res.riskAssess });
          // if(res.riskAssess &&res.riskAssess.content && res.riskAssess.content.length) {
          //   let riskAssess = res.riskAssess;

          //   res.riskAssess.content.forEach(item=> {
          //     if(item[1] && item[1] === '.'){
          //     }
          //   })
          // }
          this.bgUrl = res.image || bgImg;
          res.precautions && (this.precautions = res.precautions);
        })
        .catch(() => {
          this.bgUrl = bgImg;
        });
    },
    handleOpenVideoDialog(index) {
      this.dialogVisible = true;
      this.videItemIndex = index;
      this.poster = `${this.baseApi}${
        this.actionExplains[this.videItemIndex]["bgImg"]
      }`;
      this.videoSrc = `${this.baseApi}${
        this.actionExplains[this.videItemIndex]["video"]
      }`;
    },
    prevVideo() {
      if (this.videItemIndex === 0) return;
      this.videItemIndex > 0 && this.videItemIndex--;
      this.poster = `${this.baseApi}${
        this.actionExplains[this.videItemIndex]["bgImg"]
      }`;
      this.videoSrc = `${this.baseApi}${
        this.actionExplains[this.videItemIndex]["video"]
      }`;
    },
    nextVideo() {
      if (this.videItemIndex === this.actionExplains.length - 1) return;
      this.videItemIndex < this.actionExplains.length - 1 &&
        this.videItemIndex++;
      this.poster = `${this.baseApi}${
        this.actionExplains[this.videItemIndex]["bgImg"]
      }`;
      this.videoSrc = `${this.baseApi}${
        this.actionExplains[this.videItemIndex]["video"]
      }`;
    },
  },
};
</script>

<style lang="less" scoped>
.assessment-cont {
  .img-cont {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: calc(505px * 0.75);
    background-image: url("../../../assets/images/assessment_bg.jpeg");
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 100% 100%;
    .title-txt {
      font-family: Neue Plak;
      font-style: normal;
      font-weight: 800;
      font-size: calc(60px * 0.75);
      color: #ffffff;
      text-shadow: 0px 2px 3px rgba(0, 0, 0, 0.17);
    }
    .p-txt {
      margin-top: calc(20px * 0.75);
      font-family: Noto Sans SC;
      font-style: normal;
      font-weight: normal;
      font-size: calc(24px * 0.75);
      line-height: calc(22px * 0.75);
      color: #ffffff;
    }
  }
  .tips-txt {
    padding: calc(30px * 0.75) calc(104px * 0.75);
    font-family: Noto Sans SC;
    font-style: normal;
    font-weight: normal;
    font-size: calc(16px * 0.75);
    line-height: calc(30px * 0.75);
    text-align: center;
    color: #494949;
  }
}
.explain-cont {
  width: 100%;
  padding: calc(60px * 0.75) 0;
  background: rgba(247, 247, 247, 1);
  .title-txt {
    font-family: Noto Sans SC;
    font-style: normal;
    font-weight: bold;
    font-size: calc(24px * 0.75);
    line-height: calc(22px * 0.75);
    color: #000000;
    text-align: center;
  }
  .action-list {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: calc(30px * 0.75);
    .li-cont {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: calc(10px * 0.75);
      margin: 0 calc(5px * 0.75);
      border-radius: 4px;
      background-color: #ffffff;
      .video-img {
        position: relative;
        width: calc(136px * 0.75);
        height: calc(90px * 0.75);
        border-radius: 4px;
        overflow: hidden;
        .img {
          width: 100%;
          height: 100%;
        }
        .video-play {
          position: absolute;
          top: 50%;
          left: 50%;
          width: calc(36px * 0.75);
          height: calc(36px * 0.75);
          margin: calc(-18px * 0.75) 0 0 calc(-18px * 0.75);
        }
        .play-circle {
          position: absolute;
          top: 50%;
          left: 50%;
          width: calc(10px * 0.75);
          height: calc(10px * 0.75);
          margin: calc(-5px * 0.75) 0 0 calc(-5px * 0.75);
        }
      }
      .li-title {
        margin-top: calc(15px * 0.75);
        font-family: Noto Sans SC;
        font-style: normal;
        font-weight: 500;
        font-size: calc(16px * 0.75);
        line-height: calc(22px * 0.75);
        color: #000000;
      }
      .li-span {
        margin-top: calc(10px * 0.75);
        font-family: Noto Sans SC;
        font-style: normal;
        font-weight: normal;
        font-size: calc(14px * 0.75);
        line-height: calc(16px * 0.75);
        color: #494949;
      }
    }
  }
}
.matters-cont {
  padding: calc(30px * 0.75) calc(102px * 0.75);
  .title-txt {
    font-family: Noto Sans SC;
    font-style: normal;
    font-weight: bold;
    font-size: calc(24px * 0.75);
    line-height: calc(22px * 0.75);
    color: #000000;
    text-align: center;
  }
  .ul-cont {
    margin-top: calc(30px * 0.75);
    .li {
      // position: relative;
      // padding-left: calc(21px * 0.75);
      font-family: Noto Sans SC;
      font-style: normal;
      font-weight: normal;
      font-size: calc(16px * 0.75);
      line-height: calc(30px * 0.75);
      color: #494949;
      // &::before {
      //   content: "";
      //   position: absolute;
      //   top: calc(13px * 0.75);
      //   left: 0;
      //   width: calc(3px * 0.75);
      //   height: calc(3px * 0.75);
      //   border-radius: 50%;
      //   background-color: #dc0019;
      // }
    }
    .ul-cont-check {
      display: flex;
      align-items: center;
      margin-top: calc(30px * 0.75);
    }
  }
}
.submit-cont {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: calc(60px * 0.75) 0 calc(30px * 0.75) 0;
  background-color: rgba(247, 247, 247, 1);
  .submit-btn {
    width: calc(418px * 0.75);
    height: calc(64px * 0.75);
  }
  .logo-tips {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: calc(59px * 0.75);
    font-family: Noto Sans SC;
    font-style: normal;
    font-weight: 500;
    font-size: calc(14px * 0.75);
    line-height: calc(20px * 0.75);
    text-align: right;
    color: #000000;
    .logo-txt {
      width: auto;
      height: calc(20px * 0.75);
      vertical-align: middle;
    }
  }
}
/deep/.video-dialog {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  .el-dialog__header {
    position: relative;
    padding: 0;
    .el-dialog__headerbtn {
      position: absolute;
      top: calc(-43px * 0.75);
      right: 0;
      .el-icon-close {
        font-size: calc(31.5px * 0.75);
        color: #ffffff;
        &::before {
          content: "";
        }
      }
    }
  }
  .el-dialog__body {
    // display: flex;
    // flex-direction: column;
    // justify-content: center;
    // align-items: center;
    padding: 0;
    // height: 52.25%;
    border-radius: 4px;
    overflow: hidden;
  }
  .el-dialog__footer {
    position: absolute;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: calc(15px * 0.75) 0;
    font-style: normal;
    font-weight: normal;
    font-size: calc(18px * 0.75);
    line-height: calc(26px * 0.75);
    color: #f7f7f7;
    .prev-btn,
    .next-btn {
      display: flex;
      flex-direction: row;
      align-items: center;
      cursor: pointer;
    }
    .el-icon-back,
    .el-icon-right {
      font-size: calc(24px * 0.75);
      color: #ffffff;
    }
    .el-icon-back {
      margin-right: calc(15px * 0.75);
    }
    .el-icon-right {
      margin-left: calc(15px * 0.75);
    }
  }
}
/deep/.remind-dialog {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  .el-dialog__header {
    position: relative;
    text-align: center;
    height: 84px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: Noto Sans SC;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0em;
    &::after {
      content: "";
      display: block;
      position: absolute;
      bottom: 0;
      height: 1px;
      width: calc(100% - 48px);
      background: lightgray;
    }
  }
  .el-dialog__body {
    max-height: 315px;
    overflow-y: scroll;
    .remind-risk {
      font-family: "Noto Sans SC";
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 30px;
      color: #494949;
    }
    .remind-dialog-check {
      display: flex;
      align-items: center;
    }
  }
  .el-dialog__footer {
    position: relative;
    &::before {
      position: absolute;
      content: "";
      top: 0;
      display: block;
      height: 1px;
      width: calc(100% - 48px);
      background: lightgray;
    }
  }
}
.player-container {
  width: calc(677px * 0.75);
  height: calc(448px * 0.75);
}
</style>
